export const dataCustomStat = {
  type: 'object',
  required: ['Field', 'Value'],
  properties: {
    Field: {
      type: 'string',
    },
    Value: {
      type: 'string',
    },
  },
};
